
// src/components/AlertsSection.tsx
import { TruckOutlined, WarningOutlined } from "@ant-design/icons";
import { Alert } from "antd";

export const AlertsSection: React.FC = () => {
  return (
    <div style={{ marginBottom: 16 }}>
      <h2 style={{ fontSize: 14, fontWeight: 500, marginBottom: 8 }}>Alerts</h2>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      
      </div>
    </div>
  );
};

